

import React, { useEffect, useState } from 'react'
import logo from '../images/logo.svg'
import movie from '../images/movie-icon.svg'
import original from '../images/original-icon.svg'
import search from '../images/search-icon.svg'
import watchlist from '../images/watchlist-icon.svg'
import home from '../images/home-icon.svg'
import series from '../images/series-icon.svg'
import avatar from '../images/avatar.jpg'
import { auth, provider } from '../firebase'
import { signInWithPopup } from 'firebase/auth'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { selectUserName, selectUserPhoto, setSignOutState, setUserLoginDetails } from '../featurs/user/userSlice'



function Header() {

    const [isLogin,setIsLogin]=useState(false)
    const [logout,setLogout]=useState(false)
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const userName=useSelector(selectUserName)
    const userPhoto=useSelector(selectUserPhoto)

    useEffect(()=>{
        auth.onAuthStateChanged(async(user)=>{
            if(user){
                setUser(user)
              
            }
        })
    },[userName])
    const handleAuth = () => {
        if(!userName){
            signInWithPopup(auth,provider)
            .then((result) => {
              setUser(result.user)
                console.log(result);
                setIsLogin(true)
                navigate('/home')
            })
            .catch((error) => {
                console.error("Error signing in:", error);
            });
        }
        else if(userName){
            auth.signOut().then(()=>{
                dispatch(setSignOutState())
                navigate('/')
            }).catch((error)=>alert(error.message))
        }
   
    }

    const setUser=(user)=>{
   dispatch(setUserLoginDetails({
    name:user.displayName,
    email:user.email,
    photo:user.photoURL,
   }))
    }
  return (
   <nav>

    <div className='Header-logo'>
        <img src={logo} alt="" />
        {
        userName && <div className='menu'>
            <ul>
                <Link to={'/home'}>
            <li ><img src={home} alt="" />HOME</li>
            </Link>
                <li ><img src={search} alt="" />SEARCH</li>
                <li ><img src={watchlist} alt="" />WATCHLIST</li>
                <Link to={'/home/original'}>
                <li ><img src={original} alt="" />ORIGINALS</li>
                </Link>
                <li ><img src={movie} alt="" />MOVIES</li>
                <li ><img src={series} alt=""/>SERIES</li>
            </ul>
        </div>
        }
       

    </div>
{
    userName?<><div className='avater' style={logout ? { paddingTop: "30px" } : {}}>
        <div className='avater-imge'>
        <img src={userPhoto} onMouseLeave={()=>setLogout(false)} onMouseEnter={()=>setLogout(true)} style={{width:'40px',height:'40px',borderRadius:'50%'}} alt="" />
        </div>
        {
            logout && <button onClick={handleAuth} onMouseLeave={()=>setLogout(false)} onMouseEnter={()=>setLogout(true)}>Sign out</button>
        }
    
    </div></>:<div>
    <button onClick={handleAuth}>LOGIN</button>
</div>
}
    
   </nav>
  )
}

export default Header
